import React, { Suspense, lazy } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Offers from '../components/Offers';

// Lazy load below-the-fold components to reduce initial JavaScript bundle
const About = lazy(() => import('../components/About'));
const Guides = lazy(() => import('../components/Guides'));
const FAQ = lazy(() => import('../components/FAQ'));
const News = lazy(() => import('../components/News'));
const Contact = lazy(() => import('../components/Contact'));
const Footer = lazy(() => import('../components/Footer'));

const Home = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <Hero />
        <Offers />
        <Suspense fallback={null}>
          <About />
        </Suspense>
        <Suspense fallback={null}>
          <Guides />
        </Suspense>
        <Suspense fallback={null}>
          <FAQ />
        </Suspense>
        <Suspense fallback={null}>
          <News />
        </Suspense>
        <Suspense fallback={null}>
          <Contact />
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <Footer />
      </Suspense>
    </div>
  );
};

export default Home;

